import React, { Component, Fragment } from "react";
import {
    Button,
    Modal,
    Icon, Dimmer, Loader
} from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createNotification } from "react-redux-notify";
import { HotTable } from "@handsontable/react";
import { colWidths } from "./StaffAssignmentColWidths";
import { colHeaders } from "./StaffAssignmentHeaders";
import * as ccr from "../Clients/clientCellRenderer";
import { saveStaff } from "./../../actions/clients/saveEdits";
import DEFAULTS from "../../Constants/lookupDefaultValues";
import setDropdownValues from "../../Common/Utility/setDropdownValues";
import { searchUserLookUp } from "./../../actions/clients/fetchAllClients";
import StaffAssignmentCellEditor from "./StaffAssignmentCellEditor";
import { autofill } from "redux-form";

class StaffAssignmentModal extends Component {
    constructor(props) {
        super(props);
        this.hotTableComponent = React.createRef();
        this.dataSaved = false;
        this.state = {
        };
        this.settings = {
            licenseKey: "0b014-a057a-62a00-d4631-40c07",
            rowHeaders: false,
            className: "htLeft",
            fillHandle: {
                direction: "vertical",
                autoInsertRow: false
            },
            columnSorting: true,
            multiColumnSorting: false,
            manualColumnResize: true,
            manualRowResize: true,
            observeDOMVisibility: true,
            observeChanges: true,
            stretchH: "all",
            manualColumnMove: true,
            headerTooltips: {
                rows: false,
                columns: true,
                onlyTrimmed: false
            },
            hiddenColumns: { columns: [0] }
        };

        this.columns = [
            {
                data: "clientId",
                readOnly: true
            },
            {
                data: "roleName",
                allowEmpty: false,
                allowInvalid: false,
                editor: false,
                selector: "roles",
                properties: { id: "id", label: "name", value: "name" },
                selectOptions: {
                    data: null
                }
            },
            {
                data: "staffName",
                allowEmpty: false,
                allowInvalid: false,
                renderer: ccr.customDropdownRendererPlaceholder.bind(this),
                selector: "staffs",
                editor: StaffAssignmentCellEditor,
                properties: { id: "id", label: "name", value: "name" },
                selectOptions: {
                    data: null
                }
            }
        ];
    }
    componentDidMount() {
        this.searchUserDetails = this.props.searchUserLookUp(this.props.firm, 0, this.props.role);
    }

    onStaffModalClose = (showMsg, cparesponsibleId, staffClientId) => {
        this.props.closeStaffAssignmentPopup(showMsg, cparesponsibleId, staffClientId);
    };

    discardChanges = () => {
        this.props.discardChangesOnCancel();
        this.onStaffModalClose(false);
    }
    updateColumn(column) {
        if (column.selector && column.selectOptions.data == null) {
            let lookup = {
                staffs: this.props.searchUserDetails,
                roles: this.props.staffDet
            }
            column.selectOptions.data = setDropdownValues({
                data: lookup,
                defaults: DEFAULTS,
                selector: column.selector,
                properties: column.properties
            });
        }
    }
    onConfirm = () => {
        const hotInstance = this.hotTableComponent.current.hotInstance;
        if (hotInstance.getDataAtCell(0, 2) == null || hotInstance.getDataAtCell(0, 2) == 'Required Role Selection' || hotInstance.getDataAtCell(0, 2) == '') {
            hotInstance.getCellMetaAtRow(0)[2].className = hotInstance.getCellMetaAtRow(0)[2].className + ' cell-border-warning';
            hotInstance.setDataAtCell(0, 2, 'Required Role Selection');
            hotInstance.render();            
            return;
        }
        else {
            hotInstance.getCellMetaAtRow(0)[2].className = hotInstance.getCellMetaAtRow(0)[2].className.replace('cell-border-warning', '');
            hotInstance.render();
        }
        const staff = hotInstance
            .getData()
            .map(
                ([
                    clientId,
                    roleName,
                    staffs
                ]) => ({
                    clientId,
                    roleName,
                    staffs
                })
            );
        const changedStaff = staff
            .map((elem, i) => {
                elem.clientId = this.props.clientDet[0];
                elem.roleId = this.props.staffDet.filter(el => el.roleName === elem.roleName)[0].roleId;
                elem.staffName = elem.staffs ? elem.staffs : "";
                elem.staffId = elem.staffName ? ((this.props.searchUserDetails.filter(el => el.userName === elem.staffName)[0]) ?
                    (this.props.searchUserDetails.filter(el => el.userName === elem.staffName)[0].userId) :
                    this.props.staffDet.filter(el => el.roleName === elem.roleName)[0].staffId) : 0;
                return elem;
            })
            .filter(elem => elem.staffId != 0);


        this.props.saveStaff(changedStaff).then((res) => {
            this.dataSaved = res.payload.staffReportData.isSuccess;
            this.cparesponsibleId = res.payload.staffReportData.cparesponsibleId;
            this.staffClientId = res.payload.staffReportData.clientId;
            this.onStaffModalClose(this.dataSaved, this.cparesponsibleId, this.staffClientId);
        });

    };
    runForAllColumns() {
        this.columns.forEach(column => this.updateColumn(column));
    }

    showLoader() {
        return (
            <Dimmer page active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        );
    }

    render() {
        if (Object.keys(this.props.staffDet).length) {
            this.runForAllColumns();
        }


        return (
            <Modal
                open={this.props.showStaffAssignmentPopup}
                closeOnDimmerClick={false}
                centered={true}
                size="small">
                <Modal.Header>
                    <strong>Staffing - {this.props.clientDet[19]} : {this.props.clientDet[4]}</strong>
                    <Icon
                        className="confirmBoxAlign"
                        name="close"
                        onClick={() => this.onStaffModalClose(false)}
                    />
                </Modal.Header>
                <Modal.Content scrolling={true}>
                    <Fragment>
                        {this.props.staffDet.length >= 1 ? (
                            <HotTable
                                className="staffassignmentmodal"
                                ref={this.hotTableComponent}
                                settings={this.settings}
                                data={this.props.staffDet}
                                colHeaders={colHeaders}
                                colWidths={colWidths}
                                columns={this.columns}
                                beforeKeyDown={event => {
                                    if (event.keyCode === 46 || event.keyCode === 8) {
                                        event.stopImmediatePropagation();
                                    }
                                }}
                                width="100%"
                                height="calc(75vh - 185px)"
                            />) : (
                            <Dimmer active inverted>
                                <Loader inverted>Loading</Loader>
                            </Dimmer>
                        )
                        }
                    </Fragment>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content="Cancel"
                        onClick={this.discardChanges}
                    />
                    <Button
                        content={"Save"}
                        primary
                        onClick={this.onConfirm}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}
function mapStateToProps(state) {
    return {
        searchUserDetails: state.allClients.searchUserDetails

    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            createNotification,
            searchUserLookUp,
            saveStaff
        },
        dispatch
    );
}
export default connect(
    mapStateToProps, mapDispatchToProps
)(StaffAssignmentModal);
